import axios from '@/axios';
import Cookies from 'js-cookie';

const API_BASE = `${process.env.VUE_APP_API_BASE_URL}/api/accounts`;

const state = {
  token: Cookies.get('token') || '',
  refreshToken: Cookies.get('refreshToken') || '',
  user: null,
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    Cookies.set('token', token, { 
      secure: !isLocal, 
      sameSite: isLocal ? 'lax' : 'none',
      domain: isLocal ? undefined : '.inmob.com.ar',
      path: '/'
    });
  },
  SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    Cookies.set('refreshToken', refreshToken, { 
      secure: !isLocal, 
      sameSite: isLocal ? 'lax' : 'none',
      domain: isLocal ? undefined : '.inmob.com.ar',
      path: '/'
    });
  },
  SET_USER(state, user) {
    state.user = user;
  },
  LOGOUT(state) {
    state.token = '';
    state.refreshToken = '';
    Cookies.remove('token', { domain: '.inmob.com.ar', path: '/' });
    Cookies.remove('refreshToken', { domain: '.inmob.com.ar', path: '/' });
    console.log('Cookies removed');
  },
};

const actions = {
  async register({ dispatch }, payload) {
    try {
      await axios.post(`${API_BASE}/registro/`, payload);
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  async login({ commit, dispatch }, payload) {
    try {
      const { data } = await axios.post(`${API_BASE}/token/`, payload);
      commit('SET_TOKEN', data.access);
      commit('SET_REFRESH_TOKEN', data.refresh);
      await dispatch('loadUser');
      
      // Si las notificaciones están habilitadas, actualizar el token FCM
      await dispatch('syncFCMToken');
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  async refreshToken({ commit, state }) {
    try {
      const { data } = await axios.post(`${API_BASE}/token/refresh/`, {
        refresh: state.refreshToken,
      });
      commit('SET_TOKEN', data.access);
    } catch (error) {
      commit('LOGOUT');
    }
  },
  async loadUser({ commit, state }) {
    if (!state.token) {
      return;
    }
    try {
      const { data } = await axios.get(`${API_BASE}/profile/`, {
        withCredentials: true,
      });
      commit('SET_USER', data);
    } catch (error) {
      console.error('Error loading user data:', error);
      commit('LOGOUT');
    }
  },
  async updateUser({ commit }, payload) {
    try {
      const { data } = await axios.put(`${API_BASE}/profile/`, payload, {
        withCredentials: true,
      });
      commit('SET_USER', data);
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  logout({ commit }) {
    commit('LOGOUT');
  },
  
  async syncFCMToken({ state }) {
    try {
      // Solo sincronizar si el usuario está autenticado y las notificaciones están habilitadas
      if (!state.token) return;
      
      const fcmToken = localStorage.getItem('fcm_token');
      const notificationsEnabled = localStorage.getItem('fcm_notifications_enabled') === 'true';
      
      if (fcmToken && notificationsEnabled) {
        await axios.post(`${API_BASE}/fcm-token/`, 
          { fcm_token: fcmToken },
          { withCredentials: true }
        );
        console.log('Token FCM sincronizado tras login');
      }
    } catch (error) {
      console.error('Error sincronizando token FCM:', error);
    }
  },
};

const getters = {
  isAuthenticated: state => !!state.token,
  getUser: state => state.user,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};